import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-[#F3F6FC]" data-id="element-82" data-mp="3djueifd6yagl">
      <div className="max-w-5xl mx-auto" data-id="element-83" data-mp="3dkm9pp2vm66c">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-[#0B1F4D] text-center mb-12 uppercase" data-id="element-84" data-mp="3ij70yz05hfin">
          Everything Included in <span className="text-[#1236C0]" data-id="element-85" data-mp="3mlttz38k56hf">Electrical Technology Instructor Atlas</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-86" data-mp="xrwub44ioovs">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-[#0B1F4D] border-b-4 border-[#F5C400] rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-87" data-mp="11sqg9ryeftm1">
              <Icon size={28} className="text-[#FFD60A]" aria-hidden="true" data-id="element-88" data-mp="1dbrd0r1okrac" />
              <span className="text-white font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-89" data-mp="18b3l835mo6f2">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-90" data-mp="zaope9v1f8xb">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-[#D2DCEC] rounded-xl p-4 flex items-center gap-3" data-id="element-91" data-mp="ujggrg1j7rl7">
              <span className="w-9 h-9 rounded-lg bg-[#0B1F4D] text-[#FFD60A] flex items-center justify-center shrink-0" data-id="element-92" data-mp="kmc2s3hub2fh">
                <Icon size={18} aria-hidden="true" data-id="element-93" data-mp="gkqjo0epprwu" />
              </span>
              <span className="text-[#0B1F4D] font-bold text-xs uppercase leading-tight" data-id="element-94" data-mp="blm9b6g1xo4x">{label}</span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-[#0B1F4D] rounded-3xl p-8 md:p-12 shadow-xl shadow-[#0B1F4D]/10 text-center" data-id="element-95" data-mp="1wyv7w6p7md6">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-8" loading="lazy" data-id="element-96" data-mp="ko9gnxtnn6xo" />
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#0B1F4D] mb-1" data-id="element-97" data-mp="pmjgwmu8kxq5">
            ELECTRICAL TECHNOLOGY INSTRUCTOR <span className="text-[#1236C0]" data-id="element-98" data-mp="fx9loy43iyxt">ATLAS</span>
          </p>
          <p className="text-base font-semibold text-[#7A5C00] mb-3" data-id="element-99" data-mp="fvgdhedu46np">
            The Complete 6-IN-1 Visual Electrical Systems &amp; Technical Training System for Electrical Instructors, Technical Schools &amp; Training Workshops
          </p>
          <p className="text-base text-slate-700/80 max-w-2xl mx-auto mb-8" data-id="element-100" data-mp="2t3psbl814s31">
            A complete visual training system created to help electrical instructors plan, explain, demonstrate
            and assess every core electrical skill with more clarity, structure and confidence.
          </p>
          <p className="text-sm font-bold tracking-widest text-[#0B1F4D] mb-1" data-id="element-101" data-mp="2xufwww8msqwo">YOUR PRICE:</p>
          <p className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#1236C0] mb-6" data-id="element-102" data-mp="2a4v8hxtpl1g0">
            {PRICE_LABEL}
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-103" data-mp="257v3lq8li4qh">
            {PRIMARY_CTA}
          </Button>
          <p className="text-xs text-slate-500 mb-10" data-id="element-104" data-mp="2e5nl911shoh1">
            Immediate Access · 6 Visual Volumes · 5 Bonuses · One-Time Payment
          </p>
          <div className="pt-8 border-t border-[#D2DCEC]" data-id="element-105" data-mp="3pmna1moxhl6b">
            <p className="text-2xl md:text-3xl font-bold tracking-tight text-[#0B1F4D] mb-2 uppercase" data-id="element-106" data-mp="3po83ta3f5034">
              Stop Planning Every Electrical Class From Scratch.
            </p>
            <p className="text-lg font-semibold text-[#7A5C00]" data-id="element-107" data-mp="tq99avaqxfms">OPEN IT. CHOOSE IT. SHOW IT. TEACH IT.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}